import currencyCodes from './formatNumber/currencyCodes'

export default function GetCurrencyCode() {
  const locale = global.currentLocale || 'es_CL'

  return currencyCodes[locale]
}
